import React from "react";
import styled from "styled-components";
import { techToCapitalization, techToImage } from "../constants";
import { GreenOutlineButton } from "../r2components/ThemeButton";
interface GridProps {
  columns: number;
}

const SmallGreenOutlineButton = styled(GreenOutlineButton)`
  padding: 0px;
  width: 100px;
  height: 20px;
  @media screen and (max-width: 415px) {
    font-size: var(--global-font-size-xs);
    height: 10px;
    width: 80px;
  }
`;

const MacroContainer = styled.div<GridProps>`
  display: grid;
  grid-template-columns: ${(props) => "repeat(" + props.columns + ", 1fr)"};
`;

const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const technologies = [
  "go",
  "java",
  "javascript",
  "typescript",
  "python",
  "ruby",
  "react",
  "rails",
  "flask",
  "django",
  "nodejs",
  "express",
  "jquery",
  "docker",
  "kubernetes",
  "nginx",
  "terraform",
  "spring",
  "jwt",
];

const Icon = styled.img`
  height: 32px;
  max-width: 64px;
  margin: 16px;
  @media screen and (max-width: 415px) {
    height: 20px;
    max-width: 40px;
    margin: 8px;
  }
`;

const Label = styled.p`
  text-align: center;
  color: var(--global-blue-gray);
  margin: 0 4px;
  @media screen and (max-width: 415px) {
    font-size: var(--global-font-size-xs);
  }
`;

interface Props {
  show_link?: boolean;
  columns?: number;
  num_icons?: number;
}

const LangsFrameworksChart: React.FC<Props> = ({
  show_link = true,
  columns = 5,
  num_icons = technologies.length,
}) => {
  const technologies_subset = technologies.slice(0, num_icons);
  return (
    <MacroContainer columns={columns}>
      {technologies_subset.map((tech, idx) => (
        <IconContainer>
          <Icon src={techToImage[tech]} key={idx} alt={tech} />
          <Label>{techToCapitalization[tech]}</Label>
        </IconContainer>
      ))}
      {show_link && (
        <IconContainer>
          <Icon src={techToImage["all"]} key={"last"} alt={"list-icon"} />
          <SmallGreenOutlineButton href="/r">
            see all rules
          </SmallGreenOutlineButton>
        </IconContainer>
      )}
    </MacroContainer>
  );
};

export default LangsFrameworksChart;
